import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import UrlJoin from 'url-join';

export class ApiBaseService {
  constructor(protected baseUrl: string, protected http: HttpClient) {}

  doPost<T>(
    path: string,
    postData: object | Array<any> = {},
    headerOptions: { [key: string]: string } = {},
    responseType?: 'json' | 'text' | 'blob' | 'arraybuffer'
  ): Observable<T> {
    const apiUrl = UrlJoin(this.baseUrl, path);
    const options = {
      headers: this.getHttpHeader(headerOptions),
    };
    if (responseType) {
      Object.assign(options, { responseType });
    }

    return this.http.post<T>(apiUrl, postData, options);
  }

  doGet<T>(
    path: string,
    headerParams?: HttpParams,
    headerOptions: { [key: string]: string } = {},
    responseType?: 'json' | 'text' | 'blob' | 'arraybuffer'
  ): Observable<T> {
    const apiUrl = UrlJoin(this.baseUrl, path);
    const options = {
      headers: this.getHttpHeader(headerOptions),
    };
    if (headerParams) {
      Object.assign(options, { params: headerParams });
    }
    if (responseType) {
      Object.assign(options, { responseType });
    }

    return this.http.get<T>(apiUrl, options);
  }

  doPut<T>(
    path: string,
    putData: object | Array<any> = {},
    headerOptions: { [key: string]: string } = {},
    responseType?: 'json' | 'text' | 'blob' | 'arraybuffer'
  ): Observable<T> {
    const apiUrl = UrlJoin(this.baseUrl, path);
    const options = {
      headers: this.getHttpHeader(headerOptions),
    };
    if (responseType) {
      Object.assign(options, { responseType });
    }

    return this.http.put<T>(apiUrl, putData, options);
  }

  doDelete<T>(
    path: string,
    params?: HttpParams,
    headerOptions: { [key: string]: string } = {},
    responseType?: 'json' | 'text' | 'blob' | 'arraybuffer'
  ): Observable<T> {
    const apiUrl = UrlJoin(this.baseUrl, path);
    const options = {
      headers: this.getHttpHeader(headerOptions),
    };
    if (params) {
      Object.assign(options, { params });
    }
    if (responseType) {
      Object.assign(options, { responseType });
    }

    return this.http.delete<T>(apiUrl, options);
  }

  setBaseUrl(baseUrl: string): void {
    this.baseUrl = baseUrl;
  }

  private getHttpHeader(options: { [key: string]: string }): HttpHeaders {
    let headers = new HttpHeaders();
    if (Object.keys(options).length > 0) {
      for (const [key, value] of Object.entries(options)) {
        headers = headers.set(key, value);
      }
    }
    return headers;
  }
}
